The street line address.
